import {AccrualCode, AccrualCodeCreate} from "./@types/AccrualCode";
// Cache manejado por AxiosHttpService; este repositorio no interactúa directamente con el caché

// La caché y ETag son manejados internamente por AxiosHttpService

export class AccrualCodeRepository {
    private httpService: IHttpService;
    private baseUrl: string;


    constructor(httpService: IHttpService) {
        this.httpService = httpService;
        this.baseUrl = '/accrual_codes';
    }

    async getAll(): Promise<AccrualCode[]>{
        const response = await this.httpService.get<TKResponse<AccrualCode[]>>(this.baseUrl);
        return response.data
            .map((accrualCode) => ({ ...accrualCode, id: accrualCode.accrual_code_id }))
            .sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
    }

    async getOne(id: number): Promise<AccrualCode> {
        const response = await this.httpService.get<TKResponse<AccrualCode>>(`${this.baseUrl}/${id}`) as TKResponse<AccrualCode>;
        return { ...response.data, id: response.data.accrual_code_id };
    }
    async create(data: AccrualCodeCreate): Promise<AccrualCode> {
        const response = await this.httpService.post<TKResponse<AccrualCode>, AccrualCodeCreate>(this.baseUrl, { data });
        return response.data;
    }
    async update(id: number, data: AccrualCode): Promise<AccrualCode> {
        const response = await this.httpService.patch<TKResponse<AccrualCode>, AccrualCode>(`${this.baseUrl}/${id}`, { data });
        return { ...response.data, id: response.data.accrual_code_id };
    }
    async delete(id: number): Promise<void> {
        return await this.httpService.delete(`${this.baseUrl}/${id}`);
    }
}

